import type { A2uiSurfaceAdapterRovoMessage } from '@atlassian/a2ui-renderer-next/v0_9/a2ui-surface-adapter-rovo';

export type A2UIMessageRecord = Record<string, unknown>;

const readWrappedSurfaceId = (value: unknown): string | undefined => {
	if (value && typeof value === 'object') {
		const { surfaceId } = value as A2UIMessageRecord;
		if (typeof surfaceId === 'string') {
			return surfaceId;
		}
	}
	return undefined;
};

/** surfaceId the A2UI message addresses, or undefined when it has no discernible one. */
export const surfaceIdOf = (a2uiMessage: A2uiSurfaceAdapterRovoMessage): string | undefined => {
	const wire = a2uiMessage as A2UIMessageRecord;

	return (
		readWrappedSurfaceId(wire.createSurface) ??
		readWrappedSurfaceId(wire.updateComponents) ??
		readWrappedSurfaceId(wire.updateDataModel) ??
		readWrappedSurfaceId(wire.deleteSurface) ??
		readWrappedSurfaceId(wire.surfaceUpdate) ??
		readWrappedSurfaceId(wire.beginRendering) ??
		(typeof wire.surfaceId === 'string' ? (wire.surfaceId as string) : undefined)
	);
};
